
angular.module('mtic.components.dashboards.teacher_general')
.component('teacherClassesSchoolsClasses', {
  templateUrl: 'template.html',
  bindings: {
    school: '<',
    addMode: '=?',
    archivedStatus:'='
  },
  controllerAs: 'table',
  controller($scope, $q, $log, TeacherDataService, EventManager, language, $timeout,api, LocaleService) {
    $scope.language = language;
    $scope.getTranslation = function(slug){
      return language.get(slug);
    }
    var eventManager = new EventManager('teacherClassesSchoolsClasses', $scope);
    const table = this;
    const validator = Validator.validator();
    const is = Validator.Assert;
    table.flags = {
      loading: true,
      error: null,
      reset() {
        this.loading = true;
        this.error = null;
      },
      done(error) {
        this.loading = false;
        if(error) {
          this.error = error;
        }
      }
    }
    table.modules = []
    table.classes = []
    // $log.log($scope.table.archivedStatus,"archived-status");

    table.classMaker = {
      selectedModule: null,
      name: '',
      description: '',
      reset() {
        this.selectedModule = null;
        this.name = '';
        this.description = '';
      },
      create(){
        var {selectedModule, name, description} = this;
        var newClass = {
          module_id: selectedModule ? selectedModule.module_id : null,
          name,
          description,
          school_id: table.school.id
        }
        var validationResult = validator.validate(newClass, {
          module_id: [is.greaterThan(0)],
          school_id: [is.greaterThan(0)],
          name: [is.notBlank()],
          //description: [is.notBlank()]
        })
        $log.debug({validationResult})
        if(validationResult === true) {
          $log.debug(newClass)
          return TeacherDataService.createSchoolClass(newClass).then( function() {
            return updateSelections(true)
          })
        }else{
          window.alert('Please fill in all values!')
        }
      }
    }

    table.updateClass = function(class_id, class_name, class_description) {
      table.flags.reset();
      TeacherDataService.updateClassInfo(class_id, class_name, class_description)
      .then( function() {
        updateSelections(true);
      })
    }

    table.viewClassroom = function(classroom){
      // console.log('table.viewClassroom', classroom)
      TeacherDataService.activeClassroomId = classroom.id;
      eventManager.broadcast('teacher:view:class');
      eventManager.broadcast('teacher:change:tab', 'dashboard');
    }

    eventManager.listen('open-module-view', function(e, args){
      if(!args){
        return;
      }
      TeacherDataService.activeClassroomId = args;
      eventManager.broadcast('teacher:view:class');

      $timeout(function(){
        eventManager.broadcast('goto-module-tab', args);
      }, 500)
    })

    var getModules = function (school_id, reset) {
      return TeacherDataService.getSchoolModules({school_id, reset}).
      then( function(modules) {
        table.modules = modules;
        return;
      })
    }

    var loadingClasses = false;
    var goToModTab = function(){
      var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));      
      var item_id = urlParams.get('item_id')
      if(item_id === 'LEADERBOARD'){
        eventManager.broadcast('set:nav:selection', 'class-leaderboard');
      }else{
        eventManager.broadcast('set:nav:selection', 'modules');
      }
    }
    var getClasses = function(school_id, reset) {
      if(loadingClasses){
        return;
      }

      loadingClasses = true;
      TeacherDataService.activeSchoolId = school_id;
      var archiveStatus = table.archivedStatus || false;
      reset = reset || archiveStatus;
      if(archiveStatus){
        return TeacherDataService.getSchoolArchivedClasses(reset, school_id,true)
        .then( function(classes) {
          loadingClasses = false;
          table.classes = angular.copy(classes);
          return;
        })
      }else{
        return TeacherDataService.getSchoolClasses(reset, school_id, false)
        .then( function(classes) {
          _.each(classes, function(cur_class){
            if(cur_class.shared_users && cur_class.shared_users.length > 0){
              var shared_user_list = [];
              cur_class.shared_users.forEach(function(user){
                shared_user_list.push(user.User.UserInfo.info.first_name + ' ' + user.User.UserInfo.info.last_name )
              })
              cur_class.shared_users_list = _.toString(shared_user_list).split(',').join(', ');
              cur_class.shared_user_list_capped = cur_class.shared_users_list.substr(0, 50) + (cur_class.shared_users_list.length > 50 ? '...' : '');
            }
          })
          
          loadingClasses = false;
          table.classes = angular.copy(classes);
          if(window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened){
            var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
            var found_matching_class = false;
            for(var i=0;i<table.classes.length;i++){
              var user_class = table.classes[i];
              if(user_class.module_resource_id+'' === urlParams.get('module_id')){
                found_matching_class = true;
                TeacherDataService.activeClassroomId = user_class.id;
                eventManager.broadcast('teacher:view:class');
                $timeout(goToModTab, 100)
                break;
              }
            }
            if(!found_matching_class){
              var matching_module;
              $scope.table.modules.forEach(function(mod){
                if(mod.module_resource_id === Number(urlParams.get('module_id'))){
                  matching_module = mod;
                }
              })
              if(matching_module){   
                $timeout(function(){  
                  if(window.confirm(language.get('item_links_create_class'))){
                    table.addMode = true;
                    table.classMaker.selectedModule = matching_module;
                  }
                }, 100)   
              }else{
                window.alert(language.get('item_links_invalid_mod'))
              }
            }
          }
          eventManager.broadcast('mathletic-comp-classes', table.classes);
          return;
        })
      }
    }

    var updateSelections = function(reset) {
      $log.debug('school', table.school)
      const selectedSchool = table.school;
      $log.debug({selectedSchool})
      table.flags.reset();
      $q.all([
        getModules(selectedSchool.id, reset),
        getClasses(selectedSchool.id, reset)
      ])
      .then( function(){
        table.flags.done()
      })
    }

    
    eventManager.listen('refresh-class-list', function(){
      updateSelections(true);
    })

    table.$onInit = function() {
      updateSelections()
    };

    table.archiveClass = function(classRoom,status){
      if(classRoom.statusUpdating){
        return;
      }
      classRoom.statusUpdating = true;

      api.updateClassArchiveStatus(classRoom.id,status).then(function(data){
        // $log.log("return-data-",data);
        classRoom.statusUpdating = false;
        table.classes = _.filter(table.classes,function(each){
          return each.id !== classRoom.id;
        });
        eventManager.broadcast("updated:class:archive:status",{archived:status,class:classRoom,classes:table.classes});        
        if(status){
          eventManager.broadcast('mathletic-comp-classes', table.classes);
        }else{
          eventManager.broadcast('mathletic-comp-classes-unarchived');
        }
      });
    }
    
    eventManager.listen('mathletic-comp-classes-unarchived', function(){
      if(!table.archivedStatus){
        eventManager.broadcast('mathletic-comp-classes', table.classes);
      }
    });

    table.$onChanges = function() {
      $log.debug('school', table.school);
      $scope.table.archivedStatus = table.archivedStatus;
      updateSelections()
    };

    $scope.displayFunc = function(module){
      return module.getName()
    }

    $scope.isBlacklistedCode = function(code){
      var isBlacklisted = false;
      if (code){
        _.each(['c2018', 'c2019', 'c1917'], function(id){
          if (code.substr(code.length -id.length, id.length) === id){
            isBlacklisted = true;
          }
        })
        
      }
      return isBlacklisted;
    }

    eventManager.listen("edit:class:status:mode:on",function(e){
      $scope.openedEditCLassStatusMode = true;
    });

    eventManager.listen("edit:class:status:mode:off",function(e){
      $scope.openedEditCLassStatusMode = false;
    });

    eventManager.listen("updated:class:archive:status",function(e,modifiedInfo){
      if(modifiedInfo.archived && $scope.table.archivedStatus){
        table.classes.push(modifiedInfo.class);
      }
      else if(!modifiedInfo.archived && !$scope.table.archivedStatus){
        table.classes.push(modifiedInfo.class);
      }
    });



  }
})
